export const baseUrl = process.env.NODE_ENV === "production" ? "https://p29-training-sim.herokuapp.com" : "http://localhost:8080";

export const isTask = async (task) => {
    if (/^[0-9]+$/.test(task)) {
        const response = await fetch(`${baseUrl}/api/task?id=${task}`);
        return response.ok ? response.json() : false;
    }
    const response = await fetch(`${baseUrl}/api/task?name=${task}`);
    return response.ok ? response.json()[0] : false;
}

export const getAllTasks = async () => {
    const response = await fetch(`${baseUrl}/api/task`);
    return response.ok ? response.json() : false;
};

export const getTaskSM = async (task) => {
    const response = await fetch(`${baseUrl}/api/task/${task}/sm`);
    return response.ok ? response.json() : false;
}

export const getSubtask = async (task, subtask) => {
    const response = await fetch(`${baseUrl}/api/task/${task}/subtask/${subtask}`);
    return response.ok ? response.json() : false;
}